export enum PaymentStartTiming {
  Immediate = 'Immediate',
  NextTransferDate = 'NextTransferDate',
  SpecificMonth = 'SpecificMonth'
}
